import type { SVGProps } from 'react';
export const AttachmentSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M11.46 3.73a2.67 2.67 0 0 1 3.75.1 2.84 2.84 0 0 1 .07 3.86l-6.35 6.68-.02.02a1.66 1.66 0 0 1-2.34-.06 1.76 1.76 0 0 1-.04-2.4l5.33-5.62a.66.66 0 0 1 .94-.01c.26.26.27.69.02.95l-5.32 5.6a.4.4 0 0 0 .02.53q.1.1.24.11.12 0 .23-.08l6.32-6.65a1.5 1.5 0 0 0-.05-1.99 1.34 1.34 0 0 0-1.88-.06l-6.34 6.66a2.55 2.55 0 0 0 0 3.55 2.35 2.35 0 0 0 3.38 0l5.25-5.43a.66.66 0 0 1 .95 0c.26.25.26.68 0 .95l-5.24 5.43a3.67 3.67 0 0 1-5.3 0 3.9 3.9 0 0 1 0-5.44l6.35-6.67z"
      clipRule="evenodd"
    />
  </svg>
);
